import {useState} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useSkuList = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, search) => {
    setLoading(true);
    try {
      let {data: data2} = await axios.post(`/saas/master-variation/inventory-detail-list`, {
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize,
        ...search
      });
      if (!data2) {
        data2 = {
          content: [],
          number: 0,
          size: 150,
          totalElements: 0
        };
      }
      const {content, number: page, size: pageSize, totalElements: total} = data2;
      setData({
        tableData: content,
        pageInfo: {
          page: page + 1,
          pageSize,
          total
        }
      });
      return {
        tableData: content,
        pageInfo: {
          page: page + 1,
          pageSize,
          total
        }
      };
    } catch (error) {
      handleError(error);
      return {
        tableData: data,
        pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    tableDataLoading: loading,
    tableData: data,
    setTableData: setData,
    fetchTableData: fetchData
  };
};
export const useAddProductToWarehouse = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const res = await axios.post("/saas/shelfInventories/register/combo/batch", params);
      setData(res ? res.data || {} : {});
      return res;
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  return {
    loading,
    data,
    fetchData
  };
};
